export const COURSE_PAUSE_RESCHEDULE_MODAL_STAGES = {
  notOpen: 'notOpen',
  manage: 'manage',
  unschedule: 'unschedule',
  success: 'success',
};
